/* import __COLOCATED_TEMPLATE__ from './end-to-end-preview-url-builder.hbs'; */
/* RESPONSIBLE TEAM: team-actions */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type Session from 'embercom/services/session';

interface Args {
  shareableFinToken?: string;
}

interface Signature {
  Args: Args;
  Blocks: {
    default: [
      {
        messengerUrl: string;
      },
    ];
  };
  Element: HTMLElement;
}

export default class EndToEndPreviewUrlBuilder extends Component<Signature> {
  @service declare appService: $TSFixMe;
  @service declare session: Session;

  get appId() {
    return this.appService.app.id;
  }

  get messengerUrl() {
    // Add `&local_client=true` to the end of the URL to see changes to intercom-js code in the preview.
    let iframeUrl = `${window.location.origin}/hosted_messenger/${this.appId}/fin_e2e_preview?preview_only=true&intercom_disable_cookies=true`;

    if (this.args.shareableFinToken) {
      iframeUrl += `&source=shareablefinpreview&token=${this.args.shareableFinToken}`;
    }

    return iframeUrl;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::Preview::EndToEndPreviewUrlBuilder': typeof EndToEndPreviewUrlBuilder;
    'workflows/preview/end-to-end-preview-url-builder': typeof EndToEndPreviewUrlBuilder;
  }
}
